import { get } from 'lodash'

export const getBadgeIconImg = (award, badge, isObtained) => {
    const awardLvl = get(award, 'awardLevel.value')

    const imgMap = get(badge, 'organizationBadgeConfiguration.imageMap')

    if (imgMap && imgMap[awardLvl]) {
        return isObtained ? imgMap[awardLvl].active : imgMap[awardLvl].inactive
    }

    return ''
}
